'use client';

import { useRouter } from 'next/navigation';


const CTASection = () => {
  const router = useRouter();

  const handleGetStarted = () => {
    router?.push('/creator-stage-selection');
  };

  return null;
};

export default CTASection;